import React from 'react'
import { GetInTouch } from '@/custom/components/molecules/GetInTouch'
import '../OemDetails/OemDetails.css'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import '../AuctionRoom/AuctionRoom.css'
import './ValuationServices.css'
import instant from '../../assets/images/instant-val-left-img.png'
import advanceRight from '../../assets/images/advance-right-image.png'
import bannerImage from '../../assets/images/valuation-banner.png'
import commercialImg from '../../assets/images/com-veh-img.png'
import constructionImg from '../../assets/images/const-equip-img.png'
import agricultureImg from '../../assets/images/farm-equip.png'
import industrialImg from '../../assets/images/passenger-img.png'
import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
const ValuationServices = () => {
    const getThemeColors = (id) => {
        const colorSchemes = {
            1: { bgColor: 'rgb(206, 65, 65)', textColor: 'rgb(206, 65, 65)', isActive: true },
            2: { bgColor: 'rgb(0, 167, 172)', textColor: 'rgb(0, 167, 172)', isActive: true },
            3: { bgColor: 'rgb(0, 32, 91)', textColor: 'rgb(0, 32, 91)33', isActive: true },
            4: { bgColor: 'rgb(206, 65, 65)', textColor: 'rgb(206, 65, 65)', isActive: true },
            5: { bgColor: 'rgb(0, 32, 91)', textColor: 'rgb(0, 32, 91)', isActive: true },
            6: { bgColor: 'rgb(0, 167, 172)', textColor: 'rgb(0, 167, 172)', isActive: true },
            7: { bgColor: 'rgb(0, 167, 172)', textColor: 'rgb(0, 167, 172)', isActive: true },
        }

        return colorSchemes[id] || { bgColor: 'rgb(206, 65, 65)', textColor: 'rgb(206, 65, 65)' }
    }

    const params = useParams()

    const themeColors = getThemeColors(params.id)
    const themeColorChange = {
        backgroundColors: params?.bgColor || themeColors.bgColor,
        colors: params?.textColor || themeColors.textColor,
        isActive: params?.isActive || themeColors.isActive,
    }
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Valuation', link: '/valuations/servies' },
    ]
    return (
        <div className="oemDetalis auctionRoom">
            <div className="productViewCont" style={themeColorChange}>
                <div className="productViewCont-header">
                    <CustomBreadcrumbs items={breadcrumbs} />

                    <div className="productViewCont-inner valuation-container">
                        <h1>Our Valuation Services</h1>
                        <div className="auction-container">
                            <div className="section">
                                <div className="row">
                                    <div className="col-12 col-md-5">
                                        <img
                                            src={instant}
                                            alt="Valuation Services"
                                            className="valuation-image"
                                        />
                                    </div>
                                    <div className="col-12 col-md-7">
                                        <div className="card">
                                            <h2>
                                                <span className="icon">
                                                    <span className="instant-val-icon"></span>
                                                </span>
                                                Insta Valuation
                                            </h2>
                                            <p>
                                                Know the value of your equipment instantly in 3
                                                simple steps.
                                            </p>
                                            <ul>
                                                <li>Select the asset</li>
                                                <li>Fill the form</li>
                                                <li>Get the equipment report instantly</li>
                                            </ul>
                                            <div className="button">Valuate</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6 mt-3">
                                        <div className="card change-card">
                                            <h2>
                                                <span className="icon adv-val-icon-box">
                                                    <span className="adv-val-icon"></span>
                                                </span>
                                                Advance Valuation
                                            </h2>
                                            <div className="pl-3 text-left">
                                                <p>
                                                    Know the right value of your equipment • 18,000+
                                                    Valuation done
                                                </p>
                                                <ul>
                                                    <li>
                                                        Fill in the form and select the asset
                                                        details, location, and your concerns
                                                    </li>
                                                    <li>Submit the details</li>
                                                    <li>
                                                        Schedule physical inspection of your asset
                                                    </li>
                                                    <li>
                                                        Get detailed 60 checkpoints valuation report
                                                        with image & video
                                                    </li>
                                                </ul>
                                                <div className="button">Valuate</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <img
                                            src={advanceRight}
                                            alt="Valuation Right"
                                            className="valuation-image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="equipment-section mt-4">
                                <h2>Get Right Value of Used Equipment, Instantly</h2>
                                <div className="equipment-grid">
                                    <div className="equipment-item">
                                        <img src={commercialImg} alt="Commercial Vehicle" />
                                        <p>Commercial Vehicle</p>
                                    </div>
                                    <div className="equipment-item">
                                        <img src={constructionImg} alt="Construction Equipment" />
                                        <p>Construction Equipment</p>
                                    </div>
                                    <div className="equipment-item">
                                        <img src={agricultureImg} alt="Farm Equipment" />
                                        <p>Farm Equipment</p>
                                    </div>
                                    <div className="equipment-item">
                                        <img src={industrialImg} alt="Passenger Car" />
                                        <p>Passenger Car</p>
                                    </div>
                                </div>
                            </div>
                            <div className="process-section">
                                <h2>How to Get Your Asset Valuated?</h2>
                                <div className="process-steps">
                                    <img src={bannerImage} alt="Choose Assets" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ValuationServices
